export var ECustomerEmailStatus;
(function (ECustomerEmailStatus) {
    ECustomerEmailStatus[ECustomerEmailStatus["NoVerify"] = 0] = "NoVerify";
    ECustomerEmailStatus[ECustomerEmailStatus["HasVerify"] = 1] = "HasVerify";
    ECustomerEmailStatus[ECustomerEmailStatus["HasVerifyAndWaitVerifyForChange"] = 2] = "HasVerifyAndWaitVerifyForChange";
})(ECustomerEmailStatus || (ECustomerEmailStatus = {}));
